
define('text!templates/modules/calendar/nutrition/nutrient/list/nutrient-list.html',[],function () { return '<p class="text-center"><strong>{{serving}}</strong></p>\n<p class="box-title">{{#t}}{{title}}{{/t}}</p>\n<div class="macro-elements"></div>\n';});

